
import { defineComponent } from "vue";
import buttons from "../components/button.vue";

export default defineComponent({
  name: "header",
  components: {
    buttons,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    toggleMenuDelay() {
      setTimeout(this.toggleMenu, 100);
    },
  },
});
